import { toString, Record } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { record_type, string_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { mapIndexed, map } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty, singleton, append, delay, toList, iterate } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { toArray } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { createDisposable } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { Caption1, Text as Text$, tokens, Spinner, SearchBox } from "@fluentui/react-components";
import { ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";

class KartverketAdresse extends Record {
    constructor(adressetekst, postnummer, poststed) {
        super();
        this.adressetekst = adressetekst;
        this.postnummer = postnummer;
        this.poststed = poststed;
    }
}

function KartverketAdresse_$reflection() {
    return record_type("AddressSearch.KartverketAdresse", [], KartverketAdresse, () => [["adressetekst", string_type], ["postnummer", string_type], ["poststed", string_type]]);
}

function fetchAddresses(query) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const encoded = encodeURIComponent(query);
        return (fetch(`https://ws.geonorge.no/adresser/v1/sok?sok=${encoded}&treffPerSide=8&utkoordsys=4258&asciiKompatibel=true`).then(r => r.json())).then((_arg) => {
            const arr = _arg.adresser;
            return Promise.resolve(map((o) => (new KartverketAdresse(toString(o.adressetekst), toString(o.postnummer), toString(o.poststed))), arr));
        });
    }));
}

export function Component(componentInputProps) {
    let elems_2;
    const disabled = componentInputProps.disabled;
    const placeholder = componentInputProps.placeholder;
    const onChange = componentInputProps.onChange;
    const value = componentInputProps.value;
    const patternInput = reactApi.useState([]);
    const suggestions = patternInput[0];
    const setSuggestions = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setLoading = patternInput_2[1];
    const debounceId = reactApi.useRef(undefined);
    const dependencies = [value];
    reactApi.useEffect(() => {
        iterate((id) => {
            clearTimeout(id);
        }, toArray(debounceId.current));
        if (value.trim().length < 3) {
            setSuggestions([]);
            setLoading(false);
        }
        else {
            setLoading(true);
            const id_1 = (setTimeout((() => {
                const pr = fetchAddresses(value.trim());
                void (pr.then((results) => {
                    setSuggestions(results);
                    setLoading(false);
                    setOpen(true);
                }));
            }), 250)) | 0;
            debounceId.current = id_1;
        }
        createDisposable(() => {
            iterate((id_2) => {
                clearTimeout(id_2);
            }, toArray(debounceId.current));
        });
    }, dependencies);
    return createElement("div", createObj(ofArray([["style", {
        position: "relative",
        width: 100 + "%",
    }], ["onFocus", (_arg_1) => {
        if (suggestions.length > 0) {
            setOpen(true);
        }
    }], ["onBlur", (_arg_2) => {
        setTimeout((() => {
            setOpen(false);
        }), 150);
    }], (elems_2 = toList(delay(() => {
        let el_2;
        return append(singleton((el_2 = SearchBox, createElement(el_2, createObj(toList(delay(() => append(singleton(["style", {
            minWidth: 250,
            width: 100 + "%",
        }]), delay(() => append(singleton(["disabled", disabled]), delay(() => append(singleton(["value", value]), delay(() => {
            let matchValue;
            return append((matchValue = placeholder, (matchValue == null) ? (empty()) : singleton(["placeholder", matchValue])), delay(() => append(singleton(["onChange", (_arg_3, value_1_4) => {
                onChange(value_1_4.value);
            }]), delay(() => {
                let el;
                return patternInput_2[0] ? singleton(["contentAfter", (el = Spinner, createElement(el, {
                    size: "tiny",
                }))]) : empty();
            }))));
        })))))))))))), delay(() => {
            let elems_1;
            return (patternInput_1[0] && (suggestions.length > 0)) ? singleton(createElement("div", createObj(ofArray([["style", {
                position: "absolute",
                top: 100 + "%",
                left: 0,
                right: 0,
                zIndex: 100,
                marginTop: 4,
                backgroundColor: tokens.colorNeutralBackground1,
                border: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke1,
                borderRadius: tokens.borderRadiusMedium,
                boxShadow: "0 4px 12px var(--colorNeutralShadowAmbient), 0 8px 16px var(--colorNeutralShadowKey)",
                maxHeight: 280,
                overflowY: "auto",
            }], (elems_1 = ofArray(mapIndexed((i, s) => {
                let elems, el_4, el_6;
                return createElement("button", createObj(ofArray([["key", i], ["style", {
                    display: "block",
                    width: 100 + "%",
                    textAlign: "left",
                    padding: ((8 + "px ") + 12) + "px",
                    backgroundColor: "transparent",
                    border: (((0 + "px ") + "none") + " ") + "transparent",
                    borderBottom: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke3,
                    cursor: "pointer",
                    fontSize: 0.875 + "rem",
                    color: tokens.colorNeutralForeground1,
                }], ["onMouseDown", (e) => {
                    e.preventDefault();
                }], ["onClick", (_arg_4) => {
                    onChange(`${s.adressetekst}, ${s.postnummer} ${s.poststed}`);
                    setOpen(false);
                }], (elems = [(el_4 = Text$, createElement(el_4, {
                    style: {
                        display: "block",
                    },
                    children: s.adressetekst,
                })), (el_6 = Caption1, createElement(el_6, {
                    style: {
                        display: "block",
                        color: tokens.colorNeutralForeground3,
                    },
                    children: `${s.postnummer} ${s.poststed}`,
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
            }, suggestions)), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

//# sourceMappingURL=AddressSearch.jsx.map
